import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { getVisibilityOfMaintenanceModeScreen } from '../../core/states/app/app.selector';
import { Store } from '@ngrx/store';

@Component({
  standalone: false,
  selector: 'ssc-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppLayoutComponent implements OnInit {
  @Input() public containerSize: 'small' | 'medium' | 'full' = 'full';
  @Input() public showFooterContactButton = false;

  public showMaintenanceMode$: Observable<boolean>;

  constructor(private store: Store) {}

  public ngOnInit(): void {
    this.showMaintenanceMode$ = this.store.select(getVisibilityOfMaintenanceModeScreen);
  }
}
